<div class="kt-widget24">
  <div class="kt-widget24__details">
    <div class="kt-widget24__info">
      <a [routerLink]="url"><h4 class="kt-widget24__title test1">{{title}}</h4></a>
      <span class="kt-widget24__desc">
        {{description}}
      </span>
    </div>
    <a [routerLink]="url">
      <span class="kt-widget24__stats kt-font-{{color}}">
        {{before}}{{value}}{{after}}
      </span>
    </a>
  </div>
  <div *ngIf="showProgress" class="progress progress--sm">
    <div class="progress-bar kt-bg-{{color}}" role="progressbar" [style.width.%]="(value1 / (value1 + value2)) * 100" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
  <div class="kt-widget24__action">
    <span class="kt-widget24__change">
      {{before}}{{value1}}{{after}}
    </span>
    <span class="kt-widget24__number">
      {{before}}{{value2}}{{after}}
    </span>
  </div>
</div>